import React, { useState } from "react";
import { Header4 } from "@iventis/styles/src/components/texts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement } from "@iventis/styles/src/components";
import { fontSizes } from "@iventis/styles/src/atomic-rules";
import { media, styled } from "@iventis/styles";
import { Content } from "@iventis/translations/content/typed-content";
import { Theme } from "@emotion/react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

const CollapsibleSessionSection: React.FunctionComponent<{ children?: React.ReactNode; sectionName: string; initialExpanded: boolean }> = ({
    children,
    sectionName,
    initialExpanded,
}) => {
    const [expand, setExpand] = useState(initialExpanded);
    const translate = useIventisTranslate();
    const handleExpansion = (e) => {
        e.preventDefault();
        setExpand(!expand);
    };
    return (
        <StyledCollapsibleSection className="collapsible-section-outer">
            <CollapsibleSectionInner className="collapsible-section-inner" expand={expand}>
                <div className="section-header">
                    <Header4 className="section-name">{sectionName}</Header4>
                    <InteractiveElement onClick={handleExpansion}>
                        <FontAwesomeIcon className="chevron-icon" icon={expand ? "chevron-up" : "chevron-down"} />
                        <span className="hidden">{translate(expand ? Content.common.buttons.collapse : Content.common.buttons.expand)}</span>
                    </InteractiveElement>
                </div>
                {expand && (
                    <div className="section-data-fields">
                        <StyledSectionDataFieldsContainer>{children}</StyledSectionDataFieldsContainer>
                    </div>
                )}
            </CollapsibleSectionInner>
        </StyledCollapsibleSection>
    );
};

const StyledCollapsibleSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }: { theme: Theme }) => theme.otherColors.separatorDark};
`;
const CollapsibleSectionInner = styled.div<{ expand: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0.8rem 0 0.8rem 0;
    padding-bottom: ${(props) => (props.expand ? "1.3rem" : "none")};
    ${media.extraSmall} {
        margin: 0.5rem 0 0 0;
        padding-bottom: ${(props) => (props.expand ? "1rem" : "none")};
    }
    .section-name {
        flex-basis: 94%;
    }
    .section-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: ${(props) => (props.expand ? "1.3rem" : "none")};
        width: 100%;
        ${media.extraSmall} {
            margin-bottom: ${(props) => (props.expand ? "0.8rem" : "none")};
        }
    }
    .chevron-icon {
        transition: all 0.2s linear;
        cursor: pointer;
        font-size: ${fontSizes.xSmall};
        margin: 0 3px 0 3px;
        padding: 0 3px 0 3px;
    }
`;
const StyledSectionDataFieldsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.3rem;
    ${media.extraSmall} {
        gap: 0.8rem;
    }
`;

export default CollapsibleSessionSection;
